import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

export default function ReportDialog({ targetType, targetId, label = "Segnala" }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!reason.trim()) return;
    setLoading(true);
    try {
      await api.post("/reports", { target_type: targetType, target_id: targetId, reason });
      toast.success("Segnalazione inviata. Grazie per l'aiuto.");
      setOpen(false); setReason("");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="report-button" className="text-muted-foreground hover:text-destructive">
          <Flag className="w-4 h-4 mr-2" />{label}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle className="font-serif">Invia una segnalazione</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Descrivi brevemente il motivo. Un amministratore la esaminerà.</p>
        <Textarea data-testid="report-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo della segnalazione…" rows={4} />
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
          <Button data-testid="report-submit" onClick={submit} disabled={loading || !reason.trim()} className="bg-primary hover:bg-primary/90">Invia</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
